import { recordNounFor } from '@/composables/recordLayout/useRecordHeading';

/**
 * One item's name in a list of related records: its display name, else its
 * name, else its record type and id, such as "Player 2007". A Location Zone
 * Player row from the API has no display_string, so a Unit's zone players
 * read by their ids. An item with none of these has no name, and is left out.
 */
export function arrayItemName(item: unknown, classType: string): string {
    if (!item || typeof item !== 'object') {
        return '';
    }
    const record = item as Record<string, unknown>;
    const name = record.display_string || record.name;
    if (typeof name === 'string' && name !== '') {
        return name;
    }
    const id = record.id;
    if (classType !== '' && (typeof id === 'number' || typeof id === 'string')) {
        return `${recordNounFor(classType)} ${id}`;
    }
    return '';
}
